const fullHeightMinusHeaderEls = document.querySelectorAll('.js-full-height-minus-header')

function makeFullHeightMinusHeader() {
    fullHeightMinusHeaderEls.forEach(el => {
        el.style.height = `${height - headerHeight}px`;
    });
}